<ion-header>
  <ion-toolbar>
    <ion-title mode="ios" role="heading">{{ prompt }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
    <ion-grid class="time-grid">
        <ion-row class="row-time-entry">
            <ion-col size="4" class="col-hr">
                <ion-input id="hours-input" aria-labelledby="hours-label" [(ngModel)]="hrsInput" maxlength="2" type="tel"></ion-input>
            </ion-col>
            <ion-col size="1" class="col-separator">
                <div>:</div>
            </ion-col>
            <ion-col size="4" class="col-min">
                <ion-input id="minutes-input" aria-labelledby="minutes-label" [(ngModel)]="minsInput" maxlength="2" type="tel"></ion-input>
            </ion-col>
            <ion-col size="3" class="ampm">
                <div class="ampm-box">
                    <button class="am" (click)="isAM = true"                      [ngClass]="isAM === true ? 'box-selected' : 'box-unselected'"  [innerHTML]="'TIME_TYPE_IN_AM' | translate"></button>
                    <button class="pm" (click)="isAM = false; isNextDay = false;" [ngClass]="isAM === false ? 'box-selected' : 'box-unselected'" [innerHTML]="'TIME_TYPE_IN_PM' | translate"></button>
                </div>
            </ion-col>
        </ion-row>
        <ion-row class="row-label">
            <ion-col size="4">
                <ion-label id="hours-label" [innerHTML]="'TIME_TYPE_IN_HOUR' | translate"></ion-label>
            </ion-col>
            <ion-col size="1">
            </ion-col>
            <ion-col size="4">
                <ion-label id="minutes-label" [innerHTML]="'TIME_TYPE_IN_MINUTE' | translate"></ion-label>
            </ion-col>
            <ion-col size="3">
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col>
                <ion-item>
                <ion-checkbox slot="start" [(ngModel)]="isNextDay" (ionChange)="onChangeIsNextDay()"></ion-checkbox>
                <ion-label>
                    <span [innerHTML]="'TIME_TYPE_IN_NEXT_DAY' | translate"></span>
                    ({{ nextDayDisplay }})
                </ion-label>
                </ion-item>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col>
                <span *ngIf="errorBadTime" role="alert" aria-live="assertive" class="error-message">Enter a valid time</span>
                <span *ngIf="errorTooEarly" role="alert" aria-live="assertive" class="error-message">Must be after {{ minTimeDisplay }}</span>
                <span *ngIf="errorTooLate" role="alert" aria-live="assertive" class="error-message">Must be before {{ maxTimeDisplay }}</span>
            </ion-col>
        </ion-row>
    </ion-grid>

    <ion-toolbar>
        <ion-button (click)="onSubmit()" class="ion-float-right" fill="clear" color="dark" [innerHTML]="'BUTTON_OK' | translate"></ion-button>
        <ion-button (click)="dismiss()" class="ion-float-right"  fill="clear" color="dark" [innerHTML]="'BUTTON_CANCEL' | translate"></ion-button>
    </ion-toolbar>
</ion-content>
